/**
 * Shrink/hide the element on downward scrolling, re-show when scrolling up.
 */
class HideOnScroll {
    constructor(permaSticky = false) {
        this.element = null
        this.headerHeight = 0
        this.scrolled = 0
        this.scrolledSince = 0
        this.permaSticky = permaSticky
    }

    init(element) {
        this.element = element
        this.headerHeight = this.element.getBoundingClientRect().height
        let self = this
        window.addEventListener('scroll', () => {
            let timer = null
            if (timer) {
                clearTimeout(timer)
            }

            self.scrolledSince = pageYOffset
            timer = setTimeout(() => {
                if (self.scrolledSince != self.scrolled) {
                    self.scrollDealy()
                }
            }, 250)
        })
    }

    // detect scrolling and add/remove classes accordingly
    scrollDealy() {
        var heightPlus = this.headerHeight + 100

        if (this.scrolledSince < 2) {
            this.element.classList.remove('slideUp')
        } else {
            this.element.classList.add('slideUp')
        }

        if(!this.permaSticky) {
            if (
                this.scrolledSince > heightPlus &&
                this.scrolled < this.scrolledSince
            ) {
                this.element.classList.add('off-canvas')
            } else {
                this.element.classList.remove('off-canvas')
            }
        }

        this.scrolled = this.scrolledSince
    }
}

export default HideOnScroll
